import { useRouter } from 'next/router';
import Link from 'next/link';
// configs
import { SEARCH_BY_DRUG_NON_AR } from 'config/flags';
// components
import { Col, Row } from 'rsuite';
// utils && hooks
import { capitalizeEveryFirstLetter } from 'utils/strings/capitalizeEveryFirstLetter';
// styles
import styles from './MainDrug.module.css';

const MainDrug = ({ item, selectedIndex, index, handleOpen }) => {
    const {
        query: { clientId, posId },
    } = useRouter();

    const baseUrl = `/${clientId}/efficient-purchase/${posId}/search-results`;
    const searchParams = new URLSearchParams({
        search: item.drug,
        searchByDrug: 'true',
    });

    if (item?.concentration && item?.concentration?.trim() !== '') {
        searchParams.append('concentration', item.concentration);
    }

    return (
        <Link
            href={
                SEARCH_BY_DRUG_NON_AR
                    ? `${baseUrl}?${searchParams.toString()}`
                    : `/${clientId}/efficient-purchase/${posId}/search-results?search=${encodeURIComponent(
                          item.drug,
                      )}&concentration=${encodeURIComponent(item.concentration)}`
            }
            onClick={() => {
                handleOpen(false);
            }}
        >
            <Row
                className={selectedIndex === index ? styles['container-row-hover'] : styles['container-row']}
                //@ts-ignore
                tabIndex="0"
            >
                <Col xs={24}>
                    <div className={styles['wrapper-product']}>
                        <p className={styles['name']}>
                            {capitalizeEveryFirstLetter(`${item.drug} ${item.concentration}`)}
                        </p>
                        <p className={styles['quantity']}>Productos encontrados: {item.count}</p>
                    </div>
                </Col>
            </Row>
        </Link>
    );
};

export default MainDrug;
